// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-text {
  color: #382738;
  font-size: 12px;
  font-weight: bold;
}

.data-confirmed {
  margin-left: 2px;
  display: inline;
  vertical-align: middle;
  text-align: right;
  font-size: 14px;
}

.interviewInValidation {
  text-align: end;
}

.arrow-container {
  float: right;
}

.last-saved {
  background-color: #F7F7F8;
}

.info-img {
  margin-left: 6px;
}

.team-name-div {
  font-size: 18px;
  font-weight: bold;
  color: #37003C;
  margin-left: 0px !important;
}

.info-text-block {
  float: left;
  margin-left: 0;
}

.span-v-center {
  display: inline-flex;
  align-items: center;
}

select.form-control {
  height: unset !important;
}

.form-group {
  margin-bottom: 0;
}

.request-wrapper {
  margin-top: 16px;
  background-color: white;
  margin-bottom: 74px;
  border-top: 1px solid #EDEDED;
}
.request-wrapper .header {
  padding-bottom: 1rem;
  border-bottom: 1px solid #EDEDED;
}
.request-wrapper .title-text {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .subtitle-text {
  color: #6B556C;
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .section-wrapper {
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EDEDED;
}
@media (min-width: 768px) {
  .request-wrapper .section-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
@media (min-width: 1024px) {
  .request-wrapper .section-wrapper {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.request-wrapper .section-wrapper .title-wr {
  margin-top: 8px;
  margin-bottom: 10px;
}
.request-wrapper .section-wrapper .title-wr .title-text {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .section-wrapper .form-check-label {
  opacity: 0.8;
  color: #382738;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.46px;
  line-height: 18px;
}
.request-wrapper .section-wrapper .details-wrapper {
  margin-top: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #EDEDED;
  border-top: 1px solid #EDEDED;
  background-color: #FCFCFC;
}
.request-wrapper .section-wrapper .details-wrapper .title {
  color: #3E0D42;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.39px;
  line-height: 15px;
}
.request-wrapper .section-wrapper .details-wrapper .subtitle {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.69px;
  line-height: 22px;
}
.request-wrapper .section-wrapper .details-wrapper .action-text {
  margin-left: 12px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.75px;
  line-height: 14px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper {
  border: 1px solid lightgray;
  margin-bottom: 16px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper .item {
  margin: 12px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper .item-name {
  color: #3E0D42;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 16px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper .item-info {
  opacity: 0.8;
  color: #382738;
  font-size: 11px;
  letter-spacing: 0.55px;
  line-height: 18px;
}
.request-wrapper .request-footer {
  margin-top: 22px;
}
.request-wrapper .request-footer .btn {
  height: 30px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
}
.request-wrapper .request-footer .btn-outline-dark {
  color: #382738;
  border: 1px solid #EBE9EB;
  background-color: #FFFFFF;
}
.request-wrapper .additional-notes {
  color: #3E0D42;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.39px;
  line-height: 15px;
  margin-bottom: 5px;
}
.request-wrapper .notes-area {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  background-color: #FCFCFC;
  width: 100%;
  min-height: 158px;
  font-size: 11px;
}

.auto-margin {
  margin-top: auto;
  margin-bottom: auto;
}

.top20 {
  margin-top: 20px;
}

.content-offset {
  padding-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/club-interview-details/club-interview-broadcaster/club-interview-broadcaster.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;AAAJ;;AAGA;EACI,WAAA;EACA,cAAA;AAAJ;;AAGA;EACI,oBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,wBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;AAAF;AAEE;EACE,oBAAA;EACA,gCAAA;AAAJ;AAGE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AADJ;AAIE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;AAHJ;AAKI;EALF;IAMI,iBAAA;IACA,oBAAA;EAFJ;AACF;AAII;EAVF;IAWI,iBAAA;IACA,oBAAA;EADJ;AACF;AAGI;EACE,eAAA;EACA,mBAAA;AADN;AAGM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AADR;AAKI;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAHN;AAMI;EACE,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,6BAAA;EACA,yBAAA;AAJN;AAMM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAJR;AAOM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AALR;AAQM;EACE,iBAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAPR;AAUM;EACE,2BAAA;EACA,mBAAA;AARR;AAUQ;EACE,YAAA;AARV;AAWQ;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AATV;AAYQ;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAVV;AAgBE;EACE,gBAAA;AAdJ;AAgBI;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAdN;AAiBI;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAfN;AAmBE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AAlBJ;;AAsBA;EACI,gBAAA;EACA,mBAAA;AAnBJ;;AAsBA;EACI,gBAAA;AAnBJ;;AAsBA;EACI,kBAAA;AAnBJ","sourcesContent":[".status-text {\n    color: #382738;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.data-confirmed{\n  margin-left: 2px;\n  display: inline;\n  vertical-align: middle;\n  text-align: right;\n  font-size: 14px;\n}\n\n.interviewInValidation{\n  text-align: end;\n}\n\n\n.arrow-container {\n    float: right;\n}\n\n.last-saved {\n    background-color: #F7F7F8;\n}\n\n.info-img {\n    margin-left: 6px;\n}\n\n.team-name-div {\n    font-size: 18px;\n    font-weight: bold;\n    color: #37003C;\n    margin-left: 0px !important;\n}\n\n.info-text-block {\n    float: left;\n    margin-left: 0;\n}\n\n.span-v-center {\n    display: inline-flex;\n    align-items: center;\n}\n\nselect.form-control {\n    height: unset !important;\n}\n\n.form-group {\n    margin-bottom: 0;\n}\n\n.request-wrapper {\n  margin-top: 16px;\n  background-color: white;\n  margin-bottom: 74px;\n  border-top: 1px solid #EDEDED;\n\n  .header {\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #EDEDED;\n  }\n\n  .title-text {\n    color: #3E0D42;\n    font-size: 14px;\n    font-weight: bold;\n    letter-spacing: 0.5px;\n    line-height: 18px;\n  }\n\n  .subtitle-text {\n    color: #6B556C;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    line-height: 18px;\n  }\n\n  .section-wrapper {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #EDEDED;\n\n    @media (min-width: 768px) {\n      padding-top: 30px;\n      padding-bottom: 30px;\n    }\n\n    @media (min-width: 1024px) {\n      padding-top: 40px;\n      padding-bottom: 40px;\n    }\n\n    .title-wr {\n      margin-top: 8px;\n      margin-bottom: 10px;\n\n      .title-text {\n        color: #3E0D42;\n        font-size: 14px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        line-height: 18px;\n      }\n    }\n\n    .form-check-label {\n      opacity: 0.8;\n      color: #382738;\n      font-size: 13px;\n      font-weight: bold;\n      letter-spacing: 0.46px;\n      line-height: 18px;\n    }\n\n    .details-wrapper {\n      margin-top: 16px;\n      padding: 20px 0;\n      border-bottom: 1px solid #EDEDED;\n      border-top: 1px solid #EDEDED;\n      background-color: #FCFCFC;\n\n      .title {\n        color: #3E0D42;\n        font-size: 11px;\n        font-weight: bold;\n        letter-spacing: 0.39px;\n        line-height: 15px;\n      }\n\n      .subtitle {\n        color: #6B556C;\n        font-size: 11px;\n        font-weight: bold;\n        letter-spacing: 0.69px;\n        line-height: 22px;\n      }\n\n      .action-text {\n        margin-left: 12px;\n        // color: #29BB73;\n        font-size: 12px;\n        font-weight: bold;\n        letter-spacing: 0.75px;\n        line-height: 14px;\n      }\n\n      .item-wrapper {\n        border: 1px solid lightgray;\n        margin-bottom: 16px;\n\n        .item {\n          margin: 12px;\n        }\n\n        .item-name {\n          color: #3E0D42;\n          font-size: 13px;\n          font-weight: bold;\n          letter-spacing: 0.5px;\n          line-height: 16px;\n        }\n\n        .item-info {\n          opacity: 0.8;\n          color: #382738;\n          font-size: 11px;\n          letter-spacing: 0.55px;\n          line-height: 18px;\n        }\n      }\n    }\n  }\n\n  .request-footer {\n    margin-top: 22px;\n\n    .btn {\n      height: 30px;\n      border-radius: 3px;\n      font-size: 12px;\n      font-weight: bold;\n    }\n\n    .btn-outline-dark {\n      color: #382738;\n      border: 1px solid #EBE9EB;\n      background-color: #FFFFFF\n    }\n  }\n\n  .additional-notes {\n    color: #3E0D42;\n    font-size: 11px;\n    font-weight: bold;\n    letter-spacing: 0.39px;\n    line-height: 15px;\n    margin-bottom: 5px;\n  }\n\n  .notes-area {\n    border: 1px solid #EBE9EB;\n    border-radius: 3px;\n    background-color: #FCFCFC;\n    width: 100%;\n    min-height: 158px;\n    font-size: 11px;\n  }\n}\n\n.auto-margin {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.top20 {\n    margin-top: 20px;\n}\n\n.content-offset {\n    padding-left: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
